import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { serverDomain } from "../../config";
import "./login.css";

const ResetPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");
    const [step, setStep] = useState(1); // Этап: 1 - ввод email, 2 - ввод кода и нового пароля

    const handleRequest = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${serverDomain}/api/auth/reset-password-request`, { email });
            setMessage(res.data.message);
            setStep(2); // Переход ко второму этапу
        } catch (error) {
            setMessage(error.response?.data?.message || "Ошибка запроса на сброс пароля");
        }
    };

    const handleReset = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${serverDomain}/api/auth/reset-password`, { email, code, newPassword });
            setMessage(res.data.message);
            setTimeout(() => {
                navigate("/login"); // Переход на страницу входа
            }, 1000);
        } catch (error) {
            setMessage(error.response?.data?.message || "Ошибка обновления пароля");
        }
    };

    return (
        <div className="auth-page">
            <div className="login-container">
                {step === 1 ? (
                    <>
                        <h2>Запрос на сброс пароля</h2>
                        <form onSubmit={handleRequest}>
                            <input
                                type="email"
                                placeholder="E-mail"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit">Отправить код сброса</button>
                        </form>
                    </>
                ) : (
                    <>
                        <h2>Сброс пароля</h2>
                        <form onSubmit={handleReset}>
                            <input
                                type="text"
                                placeholder="Код сброса"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                required
                            />
                            <input
                                type="password"
                                placeholder="Новый пароль"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                            <button type="submit">Обновить пароль</button>
                        </form>
                    </>
                )}
                {message && <p style={{color: "red"}}>{message}</p>}
            </div>
        </div>
    );
};

// Экспортируйте компонент для использования в вашем приложении
export default ResetPassword;
